import "../components/loader/index";
import LeaderboardSinglePageController from "../controllers/LeaderboardSinglePageController";
import { GettingStartedVideoController } from "../controllers/GettingStartedVideoController";
import { VanillaPagesType } from "../core/types/VanillaPages";
import { SpotlightsSinglePageController } from "../controllers/SpotlightsSinglePageController";
import { getPathPosition } from "../core/utilities";
import TestimonialPanelController from "../controllers/TestimonialPanelController";
import { MonthlyThemePanelController } from "../controllers/MonthlyThemePanelController";
import IdeasSearchController from "../controllers/IdeasSearchController";
import ReconnectSinglePageController from "../controllers/ReconnectSinglePageController";

const leaderboard_singlepage_load = () => {
  const leaderboard = new LeaderboardSinglePageController();
  leaderboard.init(VanillaPagesType.custompage, "#CCCLeaderboard");
};

const getting_started_video_load = () => {
  const gsvCtrl = new GettingStartedVideoController();

  gsvCtrl.init("#CCCGettingStarted");
};

const spotlights_singlepage_load = () => {
  const spotlightsController = new SpotlightsSinglePageController();
  spotlightsController.init("#CCCSpotlightList");
};

const testimonial_panel_load = (categoryName: string) => {
  setTimeout(() => {
    const tp = new TestimonialPanelController();
    tp.init(VanillaPagesType.custompage, "#CCCTestimonialQuote", categoryName);
  }, 1000);
};

const monthly_theme_panel_load = () => {
  const mtpCtrl = new MonthlyThemePanelController();
  mtpCtrl.init("#CCCMonthlyTheme");
};

const ideas_search_load = async () => {
  const $body = document.querySelector("body");
  if ($body.classList.toString().includes("ccc-custompage-ideas-search")) {
    const ideasSearchController = new IdeasSearchController(
      "#CCCDiscussionsSearch"
    );
    ideasSearchController.init();
  }
};

const reconnect_single_page_load = async (): Promise<void> => {
  const $body = document.querySelector("body");
  if ($body.classList.contains("Section-ccc-custompage-reconnect")) {
    const reconnectController = new ReconnectSinglePageController();
    await reconnectController.updateTitle("#reconnectWelcome");
    await reconnectController.updateFeedbackSection(
      "#reconnectFeedbackTitle",
      "#reconnectFeedbackDescription",
      "#reconnectFeedbackBadge",
      "#reconnectFeedbackContainer"
    );
    await reconnectController.updatePersonaSection(
      "#reconnectPersonaName",
      "#reconnectPersonaDescription1",
      "#reconnectPersonaDescription2",
      "#reconnectPersonaCard",
      "#reconnectPersonaBadge"
    );
    reconnectController.displayPageContent(
      "#reconnectLoader",
      "#reconnectContent"
    );
    reconnectController.registerUserVisit();
  }
};

// seq code
const custom_pages_recipe = () => {
  console.info("Custom Pages recipe");
  const categoriesName = getPathPosition(3);

  getting_started_video_load();
  leaderboard_singlepage_load();
  spotlights_singlepage_load();
  testimonial_panel_load(categoriesName);
  monthly_theme_panel_load();
  ideas_search_load();
  reconnect_single_page_load();
};

custom_pages_recipe();
